import repositories from '..';

const resource = '/master/district';

export default {
  get: (data: any) => repositories.get(`${resource}?provinceId=${data}`),
};
